<template>
  <div>
    <b-badge
      :variant="workareaStatus.color"
      v-html="showNumber ? order.salesOrderNumber : workareaStatus.badge"
    >
    </b-badge>
  </div>
</template>

<script>
import WorkareaService from '../../services/workarea.js';

export default {
  name: 'WorkareaStatus',
  data() {
    return {
      myOrder: {},
      triedReload: false,
    }
  },
  props: {
    order: Object,
    return: Object,
    showWarning: { type: Boolean, default: true },
    showNumber: { type: Boolean, default: false },
    tryReload: { type: Boolean, default: false },
  },
  methods: {
    fetchOrder(order) {
      if(!this.order.exists && this.order.soNum && this.tryReload && !this.triedReload) {
        let vm = this;
        this.triedReload = true;
        WorkareaService.getSalesOrder(this.order.soNum).then( r => {
          this.myOrder = r;
          vm.$emit('update-workarea-order', r);
          return this.workareaStatus;
        }).catch(error => {
          this.myOrder = { exists: false }
          vm.$emit('update-workarea-order', this.myOrder)
          return this.workareaStatus;
        });
      }
    }
  },
  computed: {
    realOrder() {
      return Object.keys(this.order).length > 0 && this.order.exists ? this.order : this.myOrder;
    },
    workareaStatus() {
      const status = {
        badge: 'Cart',
        color: 'secondary',
      };

      if(!this.realOrder.exists && this.order.soNum && this.tryReload && !this.triedReload) {
        console.log('fetch ', this.order.soNum);
        status.badge = '<i class="fas fa-spinner fa-spin"></i>';
        this.fetchOrder(this.order.soNum);
        return status;
      }

      if(!this.realOrder || !this.realOrder.exists) {
        if (this.return && this.return.exists) {
          if (this.return.processed) {
            status.badge = "Processed"
            status.color = "success"
          } else if (this.return.partially_processed) {
            status.badge = "Partially Processed"
            status.color = "primary"
          } else if (this.return.waiting_on_approval) {
            status.badge = "Waiting on Approval"
            status.color = "warning"
          } else {
            status.badge = "Pending Return"
          }
        } else {
          status.badge = 'Not on Website';
        }
        return status;
      }

      if(this.realOrder.quote) {
        status.badge = 'Quote';
        status.color = 'warning';
      } else {
        if(this.realOrder.placed || this.realOrder.placed_at) {
          status.badge = 'Placed';
          status.color = 'secondary';
        } else {
          status.badge = 'Abandoned';
          status.color = 'dark';
        }

      }

      if(this.realOrder.canceled || this.realOrder.canceled_at) {
        status.badge = 'Canceled';
        status.color = 'danger';
      }

      return status;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/utility/WorkareaStatus.vue